import { render, staticRenderFns } from "./DynamicTextView.vue?vue&type=template&id=9ca6a2bc&"
import script from "./DynamicTextView.vue?vue&type=script&lang=js&"
export * from "./DynamicTextView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports